import React, { useState } from 'react';
import axios from 'axios';
import './Plans.css';
import { API_BASE } from '../utils/apiBase';

function Plans() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async (plan) => {
    setLoading(true);
    setError('');
    try {
      // Opcional: pedir email do usuário logado ou anônimo
      const email = localStorage.getItem('userEmail') || '';
      const res = await axios.post(`${API_BASE}/api/payments/checkout`, { plan, email });
      if (res.data && res.data.init_point) {
        window.location.href = res.data.init_point;
      } else {
        setError('Erro ao iniciar pagamento.');
      }
    } catch (e) {
      setError('Erro ao conectar com o Mercado Pago.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="plans-modern-bg">
      <div className="plans-modern-container">
        <h1 className="plans-hero-title">Escolha o plano ideal para você</h1>
        <p className="plans-hero-sub">Desbloqueie recursos avançados, gere QRCodes ilimitados e tenha o melhor da tecnologia QR ao seu alcance. Seu próximo nível começa aqui!</p>
        {error && <div className="message error" style={{textAlign:'center', marginBottom:16}}>{error}</div>}
        <div className="plans-modern-grid">
          <div className="plan-modern-card free">
            <div className="plan-modern-title">GRÁTIS</div>
            <div className="plan-modern-price">R$ 0 <span>/mês</span></div>
            <div className="plan-modern-desc">Possibilidade de criar e salvar até 15 QRCode gratuitamente por 10 dias<br/>Designs customizáveis<br/>Exportação PNG/SVG/PDF<br/>Histórico pessoal</div>
            <button className="plan-modern-btn selected" disabled>Seu plano atual</button>
          </div>
          <div className="plan-modern-card pro plan-modern-popular">
            <div className="plan-modern-popular-label">MAIS POPULAR</div>
            <div className="plan-modern-title">PRO</div>
            <div className="plan-modern-price">R$ 19 <span>/mês</span></div>
            <div className="plan-modern-desc"><b>Todos recursos do Grátis</b><br/>Possibilidade de criar e salvar até 15 QRCode gratuitamente por até 30 dias<br/>QR Codes dinâmicos<br/>Estatísticas de acesso<br/>Remoção da marca d'água<br/>Suporte prioritário</div>
            <button className="plan-modern-btn" onClick={()=>handleSubscribe('pro')} disabled={loading}>{loading ? 'Aguarde...' : 'Assinar Pro'}</button>
          </div>
          <div className="plan-modern-card business">
            <div className="plan-modern-title">BUSINESS</div>
            <div className="plan-modern-price">R$ 49 <span>/mês</span></div>
            <div className="plan-modern-desc">
              <b>Tudo do Pro</b><br/>
              Gere até <b>100 QRCodes</b> e armazene-os durante o período em que o plano estiver vigente<br/>
              <b>Ative e Desative</b> QRCodes quando quiser<br/>
              Gere <b>QRCodes agendados</b>, com prazo de início do funcionamento e término<br/>
              <b>Gestão de múltiplos usuários</b><br/>
              <b>Personalização avançada</b><br/>
              <b>Consultoria online</b> no apoio à geração de QRCodes
            </div>
            <button className="plan-modern-btn" onClick={()=>handleSubscribe('business')} disabled={loading}>{loading ? 'Aguarde...' : 'Assinar Business'}</button>
          </div>
          <div className="plan-modern-card donate">
            <div className="plan-modern-title">DONATIVO</div>
            <div className="plan-modern-price">Livre</div>
            <div className="plan-modern-desc">
              Apoie o projeto QRCodeXpress<br/>
              Ajude a manter a plataforma gratuita<br/>
              Receba novidades e agradecimentos
            </div>
            <button className="plan-modern-btn" onClick={()=>handleSubscribe('donate')} disabled={loading}>{loading ? 'Aguarde...' : 'Fazer Donativo'}</button>
          </div>
        </div>
        <div className="plans-modern-footer">
          Todos os planos incluem suporte por e-mail e download dos QRCodes em PNG, SVG ou PDF.<br/>
          <span className="plans-modern-footer-note">Os valores não incluem impostos. Para organizações, universidades ou escolas, <a href="/contato">entre em contato</a> para condições especiais.</span>
        </div>
        <div className="plans-payment-section">
            <img src="/mercado-pago-bandeira1s.png" alt="Meios de pagamento Mercado Pago" className="plans-payment-img" />
        </div>
      </div>
    </div>
  );
}

export default Plans;
